import {
    InstallPromptIOS as SourceInstallPromptIOS
} from 'SourceComponent/InstallPromptIOS/InstallPromptIOS.component';

import './InstallPromptIOS.style';

/** @namespace Bodypwa/Component/InstallPromptIOS/Component */
export class InstallPromptIOSComponent extends SourceInstallPromptIOS {
    render() {
        return null;
    }
}

export default InstallPromptIOSComponent;
